/**
 * Workout Timer Component
 *
 * Displays elapsed workout time in large, readable format
 * Timer starts only after first set is added
 */

import './WorkoutTimer.css';

interface WorkoutTimerProps {
  elapsedSeconds: number;
}

function formatTime(seconds: number): string {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  }
  return `${minutes}:${secs.toString().padStart(2, '0')}`;
}

export function WorkoutTimer({ elapsedSeconds }: WorkoutTimerProps): JSX.Element {
  const isActive = elapsedSeconds > 0;

  return (
    <div className="workout-timer">
      <div className="workout-timer__label">Duration</div>
      <div className={`workout-timer__time ${!isActive ? 'workout-timer__time--inactive' : ''}`}>
        {formatTime(elapsedSeconds)}
      </div>
      {isActive && (
        <div className="workout-timer__subtitle">Timer started with first set</div>
      )}
      {!isActive && (
        <div className="workout-timer__subtitle">Add a set to start timer</div>
      )}
    </div>
  );
}
